<template>
    <div class="lp-header" v-if="this.showLpHeader">
      <div class="city-search-form">
        <div class="container-md container-form">
          <div class="container-search-info">
            <label for="search-field">{{translations.searchBar.label}}</label>
            <p class="d-lg-none search-city-mob">{{this.geocodemob ? this.geocodemob : this.geocodemodel }}</p>
          </div>
          <div class="row m-0 align-items-center">
            <div class="container-search-field col-md-12 pl-md-0 d-lg-block d-none">
              <input type="text" class="form-control" id="search-field" autocomplete="off" v-model="this.geocodemodel" @input="geocodeInput()" @focusin="this.geocodes.length ? this.suggestionsdisplay = $event.target.value.trim() != '' : '' " @focusout="this.focusoutSuggestions()" @keydown="geocodeKeydown($event)" v-bind:placeholder="translations.searchBar.placeholder">
              <span class="icon icon-search-alt"></span>
              <div class="container-blocks pl-3 pr-3"><span class="search-field-linee mr-3"></span></div>
              <div class="suggestions-geocodes" v-if="!this.matchMedia.md" v-bind:class="toggleSuggestions">
                <ul class="suggestions-results" role="listbox">
                  <template v-for="(geocode, index) in this.geocodes">
                    <li class="suggestions-item" v-if="index < this.numgeocodes" v-on:click="setGeocodeToApply([geocode.geoname_id,geocode.geoname_desc]);initGeocode()">
                      <div class="suggestions-item-container">
                        <img class="item-img" :src="this.icons.citta">
                        <div class="item-info">
                          <span class="item-name">{{geocode.geoname_desc}}</span>
                          <span class="item-category">{{translations.searchBar.suggestion.label}}</span>
                        </div>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
            <div class="container-search-btn d-flex d-lg-none">
              <button type="button" class="btn btn-secondary" v-on:click="this.toggleSubFilters('geocodes')">{{this.matchMedia.sm ? translations.searchBar.buttonmobile : translations.searchBar.buttonbig}}</button>
            </div>
          </div>

        </div>

      </div>

    </div>
    <div class="container-md">
        <div class="main-content">
            <div class="filters"
                  v-if="checkFiltersVisibility()"
                 v-bind:class="this.isFiltersColOpen ? 'open' : ''">
              <div class="filtersbar-mob d-lg-none">
                <button class="btn close-refinements" v-on:click="this.toggleFilters(!this.isFiltersColOpen)"><span class="icon icon-plus btn-return" ></span></button>
                <div class="title-bar">{{ this.totelements }} partenze disponibili</div>
              </div>
              <div class="filters-container">
                <h3 class="filters-title">{{ translations.filterBar.title }}</h3>

                <div class="filter destination-slot" v-if="(this.filtersVisibility && this.filtersVisibility.destination || !this.filtersVisibility)">
                  <button class="btn btn-link btn-collapse" type="button" data-toggle="collapse"
                          data-target="#filter_destination"
                          v-bind:aria-controls="filter_destination"
                          aria-expanded="true">
                    <span class="label-category-filter">{{translations.filter.destination.label}}</span>
                    <span class="icon icon-min"></span><span class="icon icon-plus"></span>
                  </button>

                  <div class="collapse-container collapse show" id="filter_destination">
                    <div class="card-filter flex-wrap">
                      <input type="text" class="form-control inputext-filter" id="destination-field" autocomplete="off" :disabled="this.matchMedia.lg && this.subFiltersOpened.type==='destinations'" v-model="this.destinationmodel" @input="destinationInput()" @focusin="this.matchMedia.lg ? this.toggleSubFilters('destinations') : (Object.keys(this.destinations).length ? this.destinationsdisplay = $event.target.value.trim() != '' : '' )"  @focusout="this.matchMedia.lg ? '' : this.focusoutDestinations()" v-bind:placeholder="translations.filter.destination.placeholder">
                      <span class="icon icon-search-alt"></span>
                      <div class="suggestions-destinations" v-if="Object.keys(this.destinations).length && !this.matchMedia.lg" v-bind:class="toggleDestinations">
                        <ul class="suggestions-results" role="listbox">
                          <template v-if="this.destinations.nazioni">
                            <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['nazioni']" v-on:click="setDestinationToApply('nazioni',destination.valore)">
                              <div class="suggestions-item-container">
                                <img class="item-img" :src="this.icons.nazioni">
                                <div class="item-info">
                                  <span class="item-name">{{destination.valore}}</span>
                                  <span class="item-category">{{ translations.filter.destination.suggestion.nazioni }}</span>
                                </div>
                              </div>
                            </li>
                          </template>
                          <template v-if="this.destinations.viaggi">
                            <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['viaggi']" v-on:click="setDestinationToApply('nome_viaggio',destination.valore)">
                              <div class="suggestions-item-container">
                                <img class="item-img" :src="this.icons.viaggi">
                                <div class="item-info">
                                  <span class="item-name">{{destination.valore}}</span>
                                  <span class="item-category">{{ translations.filter.destination.suggestion.viaggi }}</span>
                                </div>
                              </div>
                            </li>
                          </template>
                          <template v-if="this.destinations.aree">
                            <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['aree']" v-on:click="setDestinationToApply('aree',destination.valore)">
                              <div class="suggestions-item-container">
                                <img class="item-img" :src="this.icons.aree">
                                <div class="item-info">
                                  <span class="item-name">{{destination.valore}}</span>
                                  <span class="item-category">{{ translations.filter.destination.suggestion.aree }}</span>
                                </div>
                              </div>
                            </li>
                          </template>
                          <template v-if="this.destinations.citta">
                            <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['citta']" v-on:click="setDestinationToApply('citta',destination.valore)">
                              <div class="suggestions-item-container">
                                <img class="item-img" :src="this.icons.citta">
                                <div class="item-info">
                                  <span class="item-name">{{destination.valore}}</span>
                                  <span class="item-category">{{ translations.filter.destination.suggestion.citta }}</span>
                                </div>
                              </div>
                            </li>
                          </template>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="filter datepicker-slot" v-if="(this.filtersVisibility && this.filtersVisibility.departureDate || !this.filtersVisibility)">
                  <button class="btn btn-link btn-collapse" type="button" data-toggle="collapse"
                          data-target="#filter_datepicker"
                          v-bind:aria-controls="filter_datepicker"
                          aria-expanded="true">
                    <span class="label-category-filter">{{ translations.filter.startdate.label }}</span>
                    <span class="icon icon-min"></span><span class="icon icon-plus"></span>
                  </button>

                  <div class="collapse-container collapse show" id="filter_datepicker">
                    <div class="card-filter">
                      <div class="datepicker-input-container" ref="datepickerinputcontainer">
                        <button type="button" class="datepicker-input" v-on:click="this.matchMedia.lg ? (this.toggleSubFilters('datepickermob'),$refs.datepicker.toggleDatepicker()) : $refs.datepicker.toggleDatepicker()">
                          <!--isif condition="${refinement.value}">
                            <isprint value="${refinement.value[0].displayValue}" encoding="off" />

                            <iselse>
                              ${Resource.msg('label.filter.departureRange', 'search', null)}
                          </isif-->
                          <span v-if="this.startDateFinal && this.endDateFinal">
                            {{ translations.filter.startdate.from}} <strong>{{this.startDateFinal}}</strong> {{ translations.filter.startdate.to}} <strong>{{this.endDateFinal}}</strong>
                          </span>
                          <span class="datepicker-placeholder" v-else>
                            {{ translations.filter.startdate.placeholder }}
                          </span>
                        </button>
                        <span class="arrow-datepicker icon icon-arrow-down"></span>
                      </div>
                      <datepickervue ref="datepicker" v-if="!this.matchMedia.lg" @datefinal="datefinalstamp" @datepickerfocusout="datepickerfocusout"/>
                    </div>
                  </div>
                </div>
                <template v-for="(categoryFilter, index) in Object.keys(this.getFiltersPriority)">
                  <div class="filter" v-if="Object.keys(this.getFiltersPriority[categoryFilter]).length && (this.filtersVisibility && this.filtersVisibility[categoryFilter] || !this.filtersVisibility)">
                      <button class="btn btn-link btn-collapse" type="button" data-toggle="collapse"
                              v-bind:data-target="'#filter_' + index"
                              v-bind:aria-controls="'filter_' + index"
                              aria-expanded="true">
                        <span class="label-category-filter">{{ translations.filter[categoryFilter].label }}</span>
                        <span class="icon icon-min"></span><span class="icon icon-plus"></span>
                      </button>

                      <div class="collapse-container collapse show"
                           v-bind:id="'filter_' + index">
                          <div class="card-filter" v-bind:class="categoryFilter == 'cod_disponibilita' || categoryFilter == 'fascia_importo' ?'filter-round':'filter-checkbox'">
                            <template v-for="(paramFilter, indexx) in this.getFiltersPriority[categoryFilter]">
                              <button class="btn" v-bind:class="[categoryFilter == 'cod_disponibilita' || categoryFilter == 'fascia_importo' ?'btn-filter-round':'btn-filter-checkbox',this.getFilterState(categoryFilter, paramFilter) ? 'active' : '']" v-on:click="applyFilter(categoryFilter, paramFilter, 'filter')">
                                <span class="icon" v-bind:class="this.getFilterState(categoryFilter, paramFilter) ? 'icon-checked' : 'icon-unchecked'" v-if="categoryFilter != 'cod_disponibilita' && categoryFilter != 'fascia_importo'"></span>
                                <span class="label-filter">{{ translations.filter[categoryFilter]['v'+paramFilter] ? translations.filter[categoryFilter]['v'+paramFilter] : paramFilter}}</span>
                              </button>
                            </template>
                          </div>
                      </div>
                  </div>
                </template>
              </div>
              <div class="filtersfooter-mob d-lg-none">
                <button class="btn btn-outline-secondary btn-cancelFilters" v-on:click="this.toggleFilters(!this.isFiltersColOpen)">
                  ANNULLA
                </button>
                <button class="btn btn-secondary btn-applyFilters" v-on:click="this.exeFilters({ paginaReset:false }), this.buildUrl(false), this.toggleFilters(!this.isFiltersColOpen)">
                  APPLICA FILTRI
                </button>
              </div>
            </div>
            <div class="filters-mob" v-if="this.matchMedia.lg" v-bind:class="[this.subFiltersOpened.style ? this.subFiltersOpened.style+' open' : '', 'filters-opened-mob']">
              <div class="filterssub-head" v-if="this.subFiltersOpened">
                <div class="container-head">
                  <button class="btn btn-return" v-on:click="this.subFiltersOpened.type=='datepickermob' ? ( this.toggleSubFilters(),$refs.datepicker.toggleDatepicker() ) : this.toggleSubFilters()"><span class="icon icon-return" v-bind:class="this.subFiltersOpened.returnicon"></span></button>
                  <div class="title-bar">{{this.subFiltersOpened.title}}</div>
                </div>
              </div>

              <div class="filterssub-body">

                <div class="container-orders" v-if="this.subFiltersOpened.type=='ordersmob'">
                  <p>Ordina per</p>
                  <form class="orders-form" name="orders-form">
                    <ul>
                      <li v-on:click="ordermob=['ordinamento', 'data_', 'paginationorder']"><input type="radio" id="partenza-ordermob" name="ordermob"><label for="partenza-ordermob">Partenza</label></li>
                      <li v-on:click="ordermob=['ordinamento', 'prezzo_', 'paginationorder']"><input type="radio" id="prezzo-ordermob" name="ordermob"><label for="prezzo-ordermob">Prezzo</label></li>
                    </ul>
                  </form>
                </div>

                <datepickervue ref="datepicker" opened @datefinal="datefinalstamp" v-if="this.matchMedia.lg"/>

                <div class="container-search-field" v-if="this.subFiltersOpened.type=='destinations' || this.subFiltersOpened.type=='geocodes'">
                  <input type="text" class="form-control inputext-filter" ref="destinationsinputmob" v-if="this.subFiltersOpened.type=='destinations'" autocomplete="off" v-model="this.destinationmodel" @input="destinationInput()" v-bind:placeholder="translations.filter.destination.placeholder"/>
                  <input type="text" class="form-control inputext-filter" ref="geocodesinputmob" v-if="this.subFiltersOpened.type=='geocodes'" autocomplete="off" v-model="this.geocodemodel" @input="geocodeInput()" v-bind:placeholder="translations.searchBar.placeholder">
                  <span class="icon icon-search-alt"></span>
                </div>

                <div class="suggestions-destinations" v-if="Object.keys(this.destinations).length && this.subFiltersOpened.type=='destinations'" v-bind:class="toggleDestinations">
                  <ul class="suggestions-results" role="listbox">
                    <template v-if="this.destinations.nazioni">
                      <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['nazioni']" v-bind:class="this.destinationmob[0]=='nazioni' && this.destinationmob[1]==destination.valore ? 'selected' : ''" v-on:click="this.destinationmob=['nazioni',destination.valore]">
                        <div class="suggestions-item-container">
                          <div class="item-container">
                            <img class="item-img" :src="this.icons.nazioni">
                            <div class="item-info">
                              <span class="item-name">{{destination.valore}}</span>
                              <span class="item-category">{{ translations.filter.destination.suggestion.nazioni }}</span>
                            </div>
                          </div>
                          <span class="icon icon-checked item-checked"></span>
                        </div>
                      </li>
                    </template>
                    <template v-if="this.destinations.viaggi">
                      <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['viaggi']" v-bind:class="this.destinationmob[0]=='nome_viaggio' && this.destinationmob[1]==destination.valore ? 'selected' : ''" v-on:click="this.destinationmob=['nome_viaggio',destination.valore]">
                        <div class="suggestions-item-container">
                          <div class="item-container">
                            <img class="item-img" :src="this.icons.viaggi">
                            <div class="item-info">
                              <span class="item-name">{{destination.valore}}</span>
                              <span class="item-category">{{ translations.filter.destination.suggestion.viaggi }}</span>
                            </div>
                          </div>
                          <span class="icon icon-checked item-checked"></span>
                        </div>
                      </li>
                    </template>
                    <template v-if="this.destinations.aree">
                      <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['aree']" v-bind:class="this.destinationmob[0]=='aree' && this.destinationmob[1]==destination.valore ? 'selected' : ''" v-on:click="this.destinationmob=['aree',destination.valore]">
                        <div class="suggestions-item-container">
                          <div class="item-container">
                            <img class="item-img" :src="this.icons.aree">
                            <div class="item-info">
                              <span class="item-name">{{destination.valore}}</span>
                              <span class="item-category">{{ translations.filter.destination.suggestion.aree }}</span>
                            </div>
                          </div>
                          <span class="icon icon-checked item-checked"></span>
                        </div>
                      </li>
                    </template>
                    <template v-if="this.destinations.citta">
                      <li class="suggestions-item" v-for="(destination, indexx) in this.destinations['citta']" v-bind:class="this.destinationmob[0]=='citta' && this.destinationmob[1]==destination.valore ? 'selected' : ''" v-on:click="this.destinationmob=['citta',destination.valore]">
                        <div class="suggestions-item-container">
                          <div class="item-container">
                            <img class="item-img" :src="this.icons.citta">
                            <div class="item-info">
                              <span class="item-name">{{destination.valore}}</span>
                              <span class="item-category">{{ translations.filter.destination.suggestion.citta }}</span>
                            </div>
                          </div>
                          <span class="icon icon-checked item-checked"></span>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="suggestions-geocodes" v-if="this.subFiltersOpened && this.subFiltersOpened.type=='geocodes'" v-bind:class="toggleSuggestions">
                  <ul class="suggestions-results" role="listbox">
                    <template v-for="(geocode, index) in this.geocodes">
                      <li class="suggestions-item" v-if="index < this.numgeocodes" v-bind:class="(this.geocodeToApply[0]==geocode.geoname_id && this.geocodeToApply[1]==geocode.geoname_desc) || this.geoname==geocode.geoname_id ? 'selected' : ''" v-on:click="setGeocodeToApply([geocode.geoname_id,geocode.geoname_desc])">
                        <div class="suggestions-item-container">
                          <div class="item-container">
                            <img class="item-img" :src="this.icons.citta">
                            <div class="item-info">
                              <span class="item-name">{{geocode.geoname_desc}}</span>
                              <span class="item-category">{{translations.searchBar.suggestion.label}}</span>
                            </div>
                          </div>
                          <span class="icon icon-checked item-checked"></span>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>

              <div class="filterssub-footer" v-if="this.subFiltersOpened" >
                <button class="btn btn-secondary filterssub-cta" v-bind:class="this.subFiltersOpened.type+'-cta'" v-on:click="this.subFiltersOpened.ctaFN">
                  {{ this.subFiltersOpened.cta }}
                </button>
              </div>

            </div>

            <div class="results-container">

              <div class="filters-header">
                <div class="filter-mainbar">
                  <button type="button" class="btn btn-secondary btn-toggleFilters" v-bind:class="!this.matchMedia.lg && this.isFiltersColOpen ? 'active' : ''"
                          v-on:click="this.toggleFilters(!this.isFiltersColOpen)" v-if="checkFiltersVisibility()">
                    {{ this.isFiltersColOpen ? translations.filterBar.button.open : translations.filterBar.button.close }}
                  </button>
                  <div class="result-count" :class="{'no-result': getFiltersApplied.length === 0, 'pl-0': !checkFiltersVisibility()}"><span class="result-number">{{ this.totelements }}</span> {{translations.filterBar.numresults}}</div>
                  <button type="button" class="btn btn-outline-secondary btn-toggleOrders" v-on:click="this.toggleSubFilters('ordersmob')">
                    {{ translations.filterBar.button.order }}
                  </button>
                </div>
                <div class="no-filters" v-bind:class="getFiltersApplied.length > 0 ? 'd-none' : ''">{{ translations.filterBar.nofilters }}</div>
                <button type="button" class="info-status" v-on:click="this.openModal('travel-status')" >
                  {{ translations.link.statustrip }}
                </button>
                <div class="filter-list">
                  <div class="filters-active" v-bind:class="getFiltersApplied.length > 0 ? '' : 'd-none'" v-if="checkFiltersVisibility()">
                    <button class="btn btn-link btn-filters-remove" v-on:click="this.removeAllFilters()">{{ translations.filterBar.button.reset }}</button>
                    <ul class="filters-active-list">
                      <li class="filter-actived" v-for="(element, index) in getFiltersApplied" v-on:click="applyFilter(element.split('=')[0], element.split('=')[0] == 'date' ? {data_da: element.split('=')[1].split('a')[0], data_a: element.split('=')[1].split('a')[1]} : element.split('=')[1], 'filter', true)">
                        <span class="icon icon-cancel"></span>
                        <span class="filter-actived-name" v-if="element.split('=')[0] != 'date'">
                          {{ !translations.filter[element.split('=')[0]]?element.split('=')[1] : translations.filter[element.split('=')[0]]['v'+element.split('=')[1]] ? translations.filter[element.split('=')[0]]['v'+element.split('=')[1]] : element.split('=')[1] }}
                        </span>
                        <span class="filter-actived-name" v-else>
                          {{ translations.filter.startdate.from}} <b>{{element.split('=')[1].split('a')[0].split('-').reverse().join('/')}}</b>
                          {{ translations.filter.startdate.to}} <b>{{element.split('=')[1].split('a')[1].split('-').reverse().join('/')}}</b>
                        </span>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>

              <div class="results">

                <div class="table-responsive" v-if="!this.matchMedia.lg">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col" v-on:click="applyFilter('ordinamento', 'data_', 'paginationorder')"><span class="icon icon-order icon-arrow-order" v-bind:class="this.getOrderState('ordinamento', 'data')"></span>{{ translations.tab.startdate.header }}</th>
                      <th scope="col">{{ translations.tab.days.header }}</th>
                      <th scope="col">{{ translations.tab.enddate.header }}</th>
                      <th scope="col">{{ translations.tab.nations.header }}</th>
                      <th scope="col">{{ translations.tab.name.header }}</th>
                      <th scope="col">{{ translations.tab.formula.header }}</th>
                      <th scope="col">{{ translations.tab.status.header }}</th>
                      <th scope="col" class="col-prezzo" v-on:click="applyFilter('ordinamento', 'prezzo_', 'paginationorder')"><span class="icon icon-order icon-arrow-order" v-bind:class="this.getOrderState('ordinamento', 'prezzo')"></span>{{ translations.tab.price.header }}</th>
                      <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody v-for="(element, index) in this.elements">
                    <tr class="row-main" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'success-row' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'danger-row' : 'default-row'"
                    >
                      <td class="font-weight-bold">{{ this.getDataPartenza(element.data_partenza) }}</td>
                      <td class="text-nowrap">{{ element.durata }} {{ parseInt(element.durata) == 1 ? translations.tab.days.day :  translations.tab.days.days }}</td>
                      <td>{{ this.getDataPartenza(element.data_ritorno) }}</td>
                      <td class="text-capitalize">
                        <div v-for="(nazione) in element.nazioni">
                          {{ nazione }}
                        </div>
                      </td>
                      <td class="nome-viaggio font-weight-bold text-uppercase">{{ element.nome_viaggio }}</td>
                      <td>{{ translations.tab.formula.value[element.formula_viaggio] }}</td>
                      <td class="text-uppercase" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'font-weight-bold' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'font-weight-bold danger-col' : ''">{{ translations.tab.status.value[element.cod_disponibilita] }}
                        <button class="btn btn-link btn-avviso" v-if="element.cod_disponibilita == 'QUASICONFERMATO' || element.cod_disponibilita == 'PROGRAMMATO'" v-on:click="this.openModal('confirmation-alert',confirmationModalData(element,this.userdata))"><span>{{ translations.tab.status.notify }}</span> {{ translations.tab.status.note }}</button>
                      </td>
                      <td class="text-right">
                        <div class="font-weight-bold prezzo-scontato" v-if="element.prezzo_scontato">{{ '€ ' + $filters.formatPriceFilter(element.prezzo) }}</div>
                        {{ translations.tab.price.from }} <span class="font-weight-bold">{{ $filters.formatPriceFilter(element.prezzo_scontato) || $filters.formatPriceFilter(element.prezzo)}}</span>
                      </td>
                      <td class="text-right">
                        <a v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})"
                           class="btn btn-primary link-preventivo main-lp">{{ translations.tab.buttons.quotation }}
                        </a>
                      </td>
                    </tr>
                    <tr class="row-info" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'success-row' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'danger-row' : 'default-row'">
                      <td colspan="8">
                        <div class="note-bbk" v-if="element.informazioni_bbk['note'] && this.userisbbk!=='false'">
                          <span class="label-note">NOTE INTERNE:</span> <span class="info-note" v-html="!element.informazioni_bbk ? '' : (element.informazioni_bbk['note'] ? element.informazioni_bbk['note'] : '')"></span>
                        </div>
                      </td>
                      <td colspan="1" class="text-right">
                        <a v-bind:href="this.producturl+'?pid='+element.cod_guidato+'-'+element.cod_sottoprogramma+'_'+element.data_partenza.slice(0,10)" class="btn btn-link btn-viaggio main-lp">
                          {{ translations.tab.buttons.gotour }} <span class="icon icon-arrow-preventivo icon-arrow-order"></span>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="box-mobile" v-if="this.matchMedia.lg">
                  <div class="itembox" v-for="(element, index) in this.elements" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'success-row' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'danger-row' : 'default-row'">
                    <div class="row">
                      <div class="col-12">
                        <span class="font-weight-bold">{{ this.getDataPartenza(element.data_partenza) }}</span>
                        <span class="lineebreak"></span>
                        {{ element.durata }} {{ parseInt(element.durata) == 1 ? translations.tab.days.day :  translations.tab.days.days }}
                        <span class="lineebreak"></span> <span>{{ this.getDataPartenza(element.data_ritorno) }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="text-capitalize" v-for="(nazione) in element.nazioni">
                          {{ nazione }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 font-weight-bold text-uppercase">{{ element.nome_viaggio }}</div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-formula">{{ translations.tab.formula.value[element.formula_viaggio] }}</div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-left">
                        <div class="text-uppercase" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'font-weight-bold' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'font-weight-bold danger-col' : ''">{{ translations.tab.status.value[element.cod_disponibilita] }}</div>
                        <div><button class="btn btn-link btn-avviso" v-if="element.cod_disponibilita == 'QUASICONFERMATO' || element.cod_disponibilita == 'PROGRAMMATO'" v-on:click="this.openModal('confirmation-alert',confirmationModalData(element,this.userdata))"><span>{{ translations.tab.status.notify }}</span> {{ translations.tab.status.note }}</button></div>
                      </div>
                      <div class="col-6 col-right">
                        <div class="font-weight-bold prezzo-scontato" v-if="element.prezzo_scontato">{{ '€ ' + $filters.formatPriceFilter(element.prezzo) }}</div>
                        <div class="actual-price">{{ translations.tab.price.from }} <span class="font-weight-bold">{{ $filters.formatPriceFilter(element.prezzo_scontato) || $filters.formatPriceFilter(element.prezzo)}}</span></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-7 col-sm-9 col-md-10 col-left">
                          <a v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})" class="btn btn-primary w-100 link-preventivo main-lp">
                              {{ translations.tab.buttons.quotation }}
                          </a>
                      </div>
                      <div class="col pl-0 justify-content-end col-right">
                          <a v-bind:href="this.getProductURL(element)" class="btn btn-link btn-viaggio main-lp">
                              {{ translations.tab.buttons.gotour }} <span class="icon icon-arrow-preventivo icon-arrow-order"></span>
                          </a>
                      </div>
                    </div>
                    <div class="row" v-if="element.informazioni_bbk['note'] && this.userisbbk!=='false'">
                      <div class="note-bbk col col-left" v-if="true">
                        <span class="label-note">NOTE INTERNE:</span> <span class="info-note" v-html="!element.informazioni_bbk ? '' : (element.informazioni_bbk['note'] ? element.informazioni_bbk['note'] : '')"></span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="filter-footer">
                <div class="view-size-selection" v-bind:class="totPage == 0 ? 'invisible': ''">
                  <label for="view-item-pagination">{{ translations.tab.pagination.label }}</label>
                  <select name="view-item-pagination" id="view-item-pagination" class="page-size tom-select" @change="applyFilter('record_per_pagina', $event.target.value, 'paginationorder')">
                    <option value="15" v-bind:selected="this.getOrderState('record_per_pagina', '15')">15</option>
                    <option value="30" v-bind:selected="this.getOrderState('record_per_pagina', '30')">30</option>
                    <option value="45" v-bind:selected="this.getOrderState('record_per_pagina', '45')">45</option>
                    <option value="60" v-bind:selected="this.getOrderState('record_per_pagina', '60')">60</option>
                  </select>
                </div>

                <div class="pagination-selector">
                  <button class="btn icon icon-arrow-left mr-2 p-0" v-bind:class="paginationOrderActive.pagina==0 ? 'btn-disabled' : ''" v-if="totPage!=0" v-on:click="paginationOrderActive.pagina === 0 ? '' : applyFilter('pagina', paginationOrderActive.pagina - 1, 'paginationorder')"></button>
                  <span class="current-page">{{ totPage == 0 ? 0 : paginationOrderActive.pagina+1 }}</span>/{{ totPage }}
                  <button class="btn icon icon-arrow-right ml-2 p-0" v-bind:class="paginationOrderActive.pagina+1==totPage ? 'btn-disabled' : ''" v-if="totPage!=0" v-on:click="paginationOrderActive.pagina == totPage - 1 ? '' : applyFilter('pagina', paginationOrderActive.pagina + 1, 'paginationorder')"></button>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import * as moment from 'moment';
import 'moment/locale/it';
import TomSelect from "tom-select";
import Datepickervue from "./datepickervue.vue";

moment.locale('it');

export default {
    props: [
        'dataurl',
        'geocodeurl',
        'destinationsurl',
        'spapurl',
        'producturl',
        'notifyurl',
        'datepickercssurl',
        'datepickerrangepresets',
        'iconsuggestions',
        'queryinit',
        'userisbbk',
        'assetsurl',
        'userdata',
        'filtersvisibilitystring',
        'hidelpheader',
        'pdview',
        'trans'
    ],
  data() {
    return {
      urlocation: new URL(window.location),
      timer: 0,
      suggestionsdisplay: false,
      geocodemodel: '-',
      geocodemob: '',
      geocodeToApply: [],
      geocodeIndexKey: null,
      destinationmodel: '',
      destinationmob: [],
      destinationsdisplay: false,
      ordermob: [],
      subFiltersOpened: false,
      startDateFinal: null,
      endDateFinal: null,
      matchMedia: {lg:null, md:null, sm:null},
      filter_datepicker: null,
      filter_destination: null,
      filtersVisibility: null,
      showLpHeader: true
    }
  },
    computed: {
        ...mapState([
            'url',
            'elements',
            'geocodes',
            'destinations',
            'numgeocodes',
            'filters',
            'filtersActive',
            'filtersToApply',
            'paginationOrderActive',
            'totPage',
            'isFiltersColOpen',
            'geoname',
            'datepickerpresetsrange',
            'translations',
            'icons',
            'totelements'
        ]),
        getFiltersApplied() {
          if(Object.keys(this.filtersActive).length) {
            var filtersActiveOrigin = JSON.parse(JSON.stringify(this.filtersActive));
            if(filtersActiveOrigin.data_da){
              filtersActiveOrigin.date = filtersActiveOrigin.data_da+'a'+filtersActiveOrigin.data_a;
              delete filtersActiveOrigin.data_da;
              delete filtersActiveOrigin.data_a;
            }
            var arrayFiltersActive = decodeURIComponent($.param(filtersActiveOrigin)).replaceAll('[]','').split("&");
            if(this.matchMedia.lg){
              arrayFiltersActive = arrayFiltersActive.filter(x => !this.filtersToApply.includes(x));
            }
            //cconsole.log('QUAAAAA',decodeURI($.param(filtersActiveOrigin)).replaceAll('[]','').split("&"));
            return arrayFiltersActive;
          }
          return [];
        },
        getFiltersPriority() {
          var filterspriority = {};
          var plus = null;
          var filtersLabel = Object.keys(this.filters);
          for(var i=0; i<filtersLabel.length; i++){
            var filtersValue = Object.keys(this.filters[filtersLabel[i]]);
            filterspriority[filtersLabel[i]] = [];
            plus = null;
            for(var j=0; j<filtersValue.length; j++) {
              if (filtersValue[j].indexOf('+') == 0) {
                plus = filtersValue[j];
              }else{
                filterspriority[filtersLabel[i]].push(filtersValue[j]);
              }
            }
            if(plus){
              filterspriority[filtersLabel[i]].push(plus);
            }
          }
          return filterspriority;
        },
        toggleSuggestions(){
            return this.suggestionsdisplay ? '':'d-none';
        },
        toggleDestinations(){
          return this.destinationsdisplay ? '':'d-none';
        }
    },
    watch: {
      // whenever question changes, this function will run
      geocodes(newGeocodes, oldGeocodes) {
        if (this.geocodemodel=='-' && newGeocodes.length == 1) {
          this.geocodemodel = newGeocodes[0].geoname_desc;
          this.setSelectedCity(newGeocodes[0].geoname_desc);
          this.setGeocodes({});
        }
      }
    },
    methods: {
        ...mapActions([
            'setFiltersColStatus',
            'setApplyFilter',
            'exeFilters',
            'setURI',
            'setDatepicker',
            'setGeocodes',
            'setDestinations',
            'setAssets',
            'setActiveFilters',
            'setActivePaginationOrder',
            'getResponseAPI',
            'removeFilters',
            'setModal',
            'setTrans',
            'setIcons',
            'setInfoBreakpoints',
            'setGeoname',
            'setSelectedCity'
        ]),
        initResource() {
          this.setURI([this.dataurl, this.geocodeurl, this.destinationsurl, this.spapurl, this.assetsurl, this.producturl, this.notifyurl]);
          this.setDatepicker([this.datepickercssurl,this.datepickerrangepresets]);
          this.setTrans(JSON.parse(this.trans));
          this.setIcons(JSON.parse(this.iconsuggestions));
        },
        init() {
          if (this.filtersvisibilitystring) {
            this.filtersVisibility = JSON.parse(this.filtersvisibilitystring);
          }

          if (this.hidelpheader === 'true') {
            this.showLpHeader = false;
          }

          if(this.queryinit!=='null'){
            var paginationOrderIds = ['record_per_pagina','pagina','ordinamento'];
            var h = decodeURIComponent(this.queryinit).split('&');
            var filtersApplied = {};
            var paginationOrderApplied = {};
            for(var i=0; i<h.length; i++){
              var hh = h[i].split('=');
              if(paginationOrderIds.indexOf(hh[0])!=-1){
                paginationOrderApplied[hh[0]] = hh[1];
              }
              else if(hh[0] == 'id_geoname' || hh[0] == 'data_da' || hh[0] == 'data_a') {
                filtersApplied[hh[0]] = hh[1];
                if(hh[0] == 'id_geoname')
                  this.setCookie('idgeocode',hh[1]);
              }else if(hh[0] == 'nome_viaggio' || hh[0] == 'citta' || hh[0] == 'nazioni' || hh[0] == 'aree'){
                this.destinationmodel = hh[1];
                filtersApplied[hh[0]] = hh[1];
              }
              else if(hh[0].substring(0,4) == 'utm_'){
                continue;
              }
              else if(filtersApplied[hh[0]])
                filtersApplied[hh[0]].push(hh[1]);
              else
                filtersApplied[hh[0]] = [hh[1]];
            }

            if(!paginationOrderApplied['record_per_pagina'])
              paginationOrderApplied['record_per_pagina'] = "15";

            var filtersInit = Object.assign(JSON.parse(JSON.stringify(paginationOrderApplied)),filtersApplied);

            if(!filtersInit['id_geoname'])
              filtersInit['id_geoname'] = this.getCookie('idgeocode') ? this.getCookie('idgeocode') : '3173435';//Inizializzazione o con il cookie (geocode precedentemente scelto in sessione) o con Milano

            this.getResponseAPI({url: 'geocode', param: {q: filtersInit['id_geoname']}});//si unisce alla logica sul watch

            delete filtersApplied['id_geoname'];// Cancello perchè non deve fare parte degli ActiveFilters ma ha una parametro a se

            this.getResponseAPI({url:'data', action:'init' , param: filtersInit});

            this.setActiveFilters(filtersApplied);
            this.setActivePaginationOrder(paginationOrderApplied);
          }else{
            var paginationOrderApplied = {'record_per_pagina':'15'};
            var idgeocode = this.getCookie('idgeocode') ? this.getCookie('idgeocode') : '3173435';
            this.getResponseAPI({url:'data', action:'init' , param: {id_geoname: idgeocode, record_per_pagina: paginationOrderApplied['record_per_pagina']}}); //Inizializzazione o con il cookie (geocode precedentemente scelto in sessione) o con Milano
            this.getResponseAPI({url: 'geocode', param: {q: idgeocode}});// Si unisce alla logica sul watch
            this.setActivePaginationOrder(paginationOrderApplied);
          }

          this.getResponseAPI({url: 'assets', action:'init'});
        },

        initGeocode(){
          if(this.geocodeToApply.length) {
            this.setGeoname(this.geocodeToApply[0]);
            this.getResponseAPI({
              url: 'data',
              action: 'filters',
              param: {
                id_geoname: this.geocodeToApply[0],
                record_per_pagina: this.paginationOrderActive['record_per_pagina']
              }
            });
            this.setCookie('idgeocode',this.geocodeToApply[0]);
            if(this.matchMedia.lg)
              this.buildUrl(false);
            this.geocodemob = this.geocodeToApply[1];
            this.setSelectedCity(this.geocodeToApply[1]);
            this.$refs.datepicker.resetDatepicker(true);//resetto i filtri date
            this.geocodeToApply = [];
            this.setActiveFilters({});//resetto i filtri
            this.destinationmodel = '';//resetto i filtri destination
            this.destinationmob = [];//
            this.setDestinations({});//
            this.geocodeIndexKey = null;
            if(!this.matchMedia.lg) {
              this.setGeocodes({});
            }
          }
        },
        checkFiltersVisibility() {
          return !this.filtersVisibility || Object.values(this.filtersVisibility).some(val => val === true);
        },
        getDataPartenza(date) {
            var parsedDate = moment(date);
            return parsedDate.format('D MMM YYYY');
        },
        toggleFilters(status) {
            this.setFiltersColStatus(status);
            if(window.matchMedia(`(max-width: ${getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-md`)})`).matches) {
              $('body').toggleClass('overflow-hidden', status);
            }
        },
        toggleSubFilters(type) {
          var bar = {style : 'bar-style', returnicon: 'icon-plus' ,title: null, cta: null};
          var subbar = {style : 'subbar-style', returnicon: 'icon-arrow-order' ,title: null, cta: null};
          var self = this;
          if(!this.subFiltersOpened){
            if(type=='destinations') {
              this.subFiltersOpened = subbar;
              this.subFiltersOpened.cta = 'Applica Destinazione'; // TODO: trad
              this.subFiltersOpened.ctaFN = function() { self.setDestinationToApply(self.destinationmob[0],self.destinationmob[1]); self.toggleSubFilters(); };
              this.subFiltersOpened.title = 'Destinazione'; // TODO: trad
              //this.activeFocusMob('destinationsinputmob');
            }else if(type=='geocodes'){
              this.subFiltersOpened = bar;
              this.subFiltersOpened.cta = 'Applica'; // TODO: trad
              this.subFiltersOpened.ctaFN = function() { self.initGeocode(); self.toggleSubFilters();};
              this.subFiltersOpened.title = 'Modifica ricerca'; // TODO: trad
              //this.activeFocusMob('geocodesinputmob');
            }else if(type=='datepickermob'){
              this.subFiltersOpened = subbar;
              this.subFiltersOpened.cta = 'Applica'; // TODO: trad
              this.subFiltersOpened.ctaFN = function() { self.$refs.datepicker.toggleDatepicker(); self.toggleSubFilters(); };
              this.subFiltersOpened.title = 'Modifica data'; // TODO: trad
            }else{
              this.subFiltersOpened = bar;
              this.subFiltersOpened.cta = 'Applica'; // TODO: trad
              this.subFiltersOpened.ctaFN = function() { self.applyFilter(self.ordermob[0],self.ordermob[1],self.ordermob[2]); self.toggleSubFilters(); self.buildUrl(false);};
              this.subFiltersOpened.title = 'Ordina'; // TODO: trad
            }
            this.subFiltersOpened.type = type;
          }else{
            this.subFiltersOpened = false;
          }
        },
        applyFilter(name, value, type, exe){
          if(name == 'date'){
            this.$refs.datepicker.resetDatepicker(true);
          }else if ((name == 'nome_viaggio' || name == 'citta' || name == 'nazioni' || name == 'aree') && exe){ //exe qui indica anche che sicuramente è un giro di cancellazione dato che per adesso è usato per forzare anche in mob in esecuxione immediata
            this.destinationmodel = '';
            this.destinationmob = [];
            this.setDestinations({});
          }
          if(!this.matchMedia.lg || type == 'paginationorder' || exe) {
            this.setApplyFilter([name, value, type]);
          }else{
            this.setApplyFilter([name, value, type, true]);//parametro per non mandare direttamente in esecuzione i filtri
          }
          if(!this.matchMedia.lg || (this.matchMedia.lg && exe))
            this.buildUrl(false);
        },
        getFilterState(category, name) {
          if(category && name) {
            return this.filtersActive[category] ? this.filtersActive[category].indexOf(name) != -1 : false;
          }
          return false;
        },
        getOrderState(category, name) {
          if(category && name && this.paginationOrderActive[category]) {
            if (category == 'ordinamento') {
              return name !== this.paginationOrderActive[category].split('_')[0] ? '' : this.paginationOrderActive[category].indexOf('desc') == -1 ? 'asc' : 'desc';
            }else{
              if(category == 'record_per_pagina')
              return this.paginationOrderActive[category] ? this.paginationOrderActive[category].indexOf(name) != -1 : false;
            }
          }
          return '';
        },
        geocodeInput(){
          if(this.geocodeToApply.length)
            this.geocodeToApply = [];

          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            if(this.geocodemodel.trim().length>2) {
              this.getResponseAPI({url: 'geocode', param: {q: this.geocodemodel}});
              this.suggestionsdisplay = true;
              this.geocodeIndexKey = null;
            }
          }, 1000);
        },
      geocodeKeydown(e){
        switch (event.key) {
          case "ArrowDown":
          case "ArrowUp":
            this.updateGeocodeModel(event.key);
            break;
          case "Enter":
            this.initGeocode();
            break;
        }


      },
      updateGeocodeModel(event){
        if(this.geocodemodel.trim().length>2 && this.geocodes.length) {
          if(event == 'ArrowDown'){
            if(this.geocodeIndexKey!=null)
              this.geocodeIndexKey = (this.geocodeIndexKey+1) % 5;
            else
              this.geocodeIndexKey = 0;
          }else if (event == 'ArrowUp'){
            if(!this.geocodeIndexKey)
              this.geocodeIndexKey = 5;

            this.geocodeIndexKey = (this.geocodeIndexKey-1) % 5;
          }
          this.setGeocodeToApply([this.geocodes[this.geocodeIndexKey].geoname_id,this.geocodes[this.geocodeIndexKey].geoname_desc]);
        }
      },

      destinationInput(){
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          if(this.destinationmodel.trim().length>2) {
            var categoryFiltersOrigin = JSON.parse(JSON.stringify(this.filtersActive));
            //if (categoryFiltersOrigin.nome_viaggio)
            //  delete categoryFiltersOrigin['nome_viaggio'];//cancellare dai filtri inviati all'API delle destinazioni il nome_viaggio stesso passato
            if (categoryFiltersOrigin.citta)
              delete categoryFiltersOrigin['citta'];
            if (categoryFiltersOrigin.nazioni)
              delete categoryFiltersOrigin['nazioni'];
            if (categoryFiltersOrigin.aree)
              delete categoryFiltersOrigin['aree'];
            if (categoryFiltersOrigin.nome_viaggio)
              delete categoryFiltersOrigin['nome_viaggio'];
            categoryFiltersOrigin.q = this.destinationmodel;
            categoryFiltersOrigin.id_geoname = this.geoname;
            this.getResponseAPI({url: 'destinations', param: categoryFiltersOrigin});
            this.destinationsdisplay = true;
          }
        }, 1000);
      },

      focusoutSuggestions(){
        setTimeout(() => { this.suggestionsdisplay = false } , 200);
      },

      focusoutDestinations(){
        setTimeout(() => { this.destinationsdisplay = false } , 200);
      },

      setGeocodeToApply(geocodeItem){
        this.geocodeToApply = geocodeItem;
        this.geocodemodel = geocodeItem[1];
        /*if(!this.matchMedia.lg) {
          this.setGeocodes({});
        }*/
      },
      setDestinationToApply(itemCategory, itemLabel){
          if(itemCategory) {
            this.destinationmodel = itemLabel;
            this.applyFilter(itemCategory, itemLabel, 'filter');
            if(!this.matchMedia.lg) {
              this.setDestinations({});
            }/*else{
              //this.setDestinations(Object.defineProperty({},itemCategory,{value:[{valore:itemLabel}]}));
            }*/
          }
      },
      openModal(type, data) {
        this.setModal({
          type: type,
          data: data ? data : {}
        });
      },
      removeAllFilters(){
        this.destinationmodel = '';
        this.destinationmob = [];
        this.setDestinations({});
        this.$refs.datepicker.resetDatepicker(true);
        this.removeFilters();
        this.buildUrl(true);
      },
      matchMediaFn(){
          var lg = window.matchMedia(`(max-width: ${getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-lg`)})`);
          var md = window.matchMedia(`(max-width: ${getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-md`)})`);
          var sm = window.matchMedia(`(max-width: ${getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-sm`)})`);
          var matchMediaObj = {lg: lg.matches, md: md.matches, sm: sm.matches};
          if(matchMediaObj != this.matchMedia) {
            this.matchMedia = {lg: lg.matches, md: md.matches, sm: sm.matches};
            this.setInfoBreakpoints(this.matchMedia);
          }
      },
      datefinalstamp(startdate,enddate){
        this.startDateFinal = startdate;
        this.endDateFinal = enddate;
        if(!this.matchMedia.lg)
          this.buildUrl(false);
      },
      datepickerfocusout(e,ee,datepickerOpen){
        if(datepickerOpen && !($(this.$refs.datepickerinputcontainer).find(e.srcElement).length || $(e.srcElement).hasClass('datepicker-input'))){
          this.$refs.datepicker.toggleDatepicker();
          //console.log(e,ee);
        }
      },
      activeFocusMob(refid){
        this.$nextTick(() => {
          // This callback will only be called after the
          // DOM has been updated
          this.$refs[refid].focus();
        });
      },
      buildUrl(removeAll){
        console.log(this.pdview)
        if (!this.pdview) {
          var paginationOrderActiveOrigin = JSON.parse(JSON.stringify(this.paginationOrderActive));
          var filtersCompleted = {};
          if(removeAll){
            filtersCompleted = paginationOrderActiveOrigin;
          }else {
            var filtersActiveOrigin = JSON.parse(JSON.stringify(this.filtersActive));
            filtersCompleted = Object.assign(filtersActiveOrigin, paginationOrderActiveOrigin);
          }
          filtersCompleted.id_geoname = this.geocodeToApply.length ? this.geocodeToApply[0] : this.geoname;
          var arrayFiltersActive = decodeURIComponent($.param(filtersCompleted)).replaceAll('[]', '');
          this.urlocation.search = '?' + arrayFiltersActive;
          window.history.pushState({}, "", this.urlocation);
          //console.log(this.urlocation.search);
        }
      },
      setCookie(cookieName, cookieVal, expDays) {
        var expires = null;
        if(expDays) {
          var date = new Date();
          date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
          const expires = "expires=" + date.toUTCString();
          document.cookie = cookieName + "=" + cookieVal + "; " + expires + "; path=/";
        }else{
          document.cookie = cookieName + "=" + cookieVal + "; path=/";
        }
      },
      getCookie(cookieName) {
        var name = cookieName + "=";
        var cookieDecoded = decodeURIComponent(document.cookie); //to be careful
        var cookies = cookieDecoded.split('; ');
        var res;
        for(var i=0; i<cookies.length;i++) {
          if (cookies[i].indexOf(name) === 0)
            res = cookies[i].substring(name.length);
        }
        return res;
      },
      confirmationModalData(product, userdataraw) {
          var userdata = JSON.parse(userdataraw);
          userdata.specific_input = {
            email: '',
            dati_prodotto: {
              id: product.id,
              preno_cod: product.preno_cod,
              gruppo_cod: product.gruppo_cod,
              cod_guidato: product.cod_guidato,
              cod_sottoprogramma: product.cod_sottoprogramma,
              nome_viaggio: product.nome_viaggio,
              data_partenza: product.data_partenza,
              data_partenza_timestamp: product.data_partenza_timestamp,
              data_ritorno: product.data_ritorno,
              data_ritorno_timestamp: product.data_ritorno_timestamp,
              durata: product.durata,
              prezzo: product.prezzo,
              valuta: product.valuta,
              cod_disponibilita: product.cod_disponibilita,
              url: this.getProductURL(product)
            }
          };
          return userdata;
      },
      getProductURL(product) {
          return this.producturl+'?pid='+product.cod_guidato+'-'+product.cod_sottoprogramma+'_'+product.data_partenza.slice(0,10);
      }

      /*formatPrice(price) {
            return price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
      }*/
    },
    components: {
      datepickervue: Datepickervue
    },
    created() {
      var self = this;
      this.initResource();
      this.matchMediaFn(); //matchMedia init
      window.addEventListener('resize', this.matchMediaFn);//matchMedia fired on resize
      window.addEventListener('popstate', function(event) {
        //console.log("Popstate",self.urlocation.search);
        window.location.reload();
      },false);
      this.init();
    },
    mounted: function () {

      if (this.checkFiltersVisibility()) {
        if(this.filtersActive['data_da']){
          this.startDateFinal = this.$refs.datepicker.setDateFromExt('data_da', this.filtersActive['data_da']);
        }
        if (this.filtersActive['data_a']){
          this.endDateFinal = this.$refs.datepicker.setDateFromExt('data_a', this.filtersActive['data_a']);
        }
      }

      //console.log('this.paginationOrderActive',this.paginationOrderActive);
      new TomSelect('.page-size', {
        create: false,
        sortField: {
          field: "text",
          direction: "asc"
        },
        controlInput: null,
        render: {
          option: function (data) {
            return '<div class="radio">' +
                '<input id="radio-' + data.text + '" name="radio" type="radio" tabindex="-1"' + (false === data.text ? 'checked' : '') + '>' +
                '<label for="radio-' + data.text + '" class="radio-label">' + data.text + '</label>' +
                '</div>';
          },
        }
      });
      $('.page-size.tom-select .ts-control').append('<span class="icon icon-arrow-down ml-2"></span><span class="icon icon-arrow-up ml-2"></span>');
      if (window.matchMedia("(min-width: 992px)").matches) {
        if (this.checkFiltersVisibility()) {
          $('.btn-toggleFilters').trigger('click');
        }
      }
    }
}
</script>
